// Em qual balde de margem uma consignacao entra, deduzido do TEXTO que a folha
// declara. Puro: so' string, sem I/O e sem dependencia de store.
//
// Vive no dominio porque a mesma pergunta e' feita em quatro lugares (portal do
// banco, app do servidor, camada externa, registro de divida herdada) e as
// copias ja divergiram uma vez. O comentario de _shared/margem-buckets.ts conta
// o estrago de 13/08/2026: onde a copia faltava, o padrao era
// `tipo === "EMPRESTIMO" ? comprometido : 0` e os baldes de cartao apareciam
// SEMPRE 100% livres — o servidor via margem de cartao que ja estava tomada.
//
// Sao tres tetos independentes (35% emprestimo, 5% cartao consignado, 5% cartao
// beneficio); parcela de cartao nao pode sair da margem de emprestimo.
export const BUCKETS_MARGEM = [
    "EMPRESTIMO",
    "CARTAO_CONSIGNADO",
    "CARTAO_BENEFICIOS",
];
/**
 * Classifica pelo texto da verba/produto. **NAO E' MAIS O DECISOR.**
 *
 * Rebaixado em 26/08/2026 (ADR-0003, emenda) a sugestao de tela e fallback do
 * caminho de conciliacao. Quem decide o balde e' o catalogo de rubricas
 * (`prefeitura/rubricas-store.ts`), declarado por verba e confirmado por humano.
 *
 * O motivo e' medido, nao teorico. Contra as descricoes reais do I.M.A.M.N.:
 *
 * | descricao real            | esta funcao | verdade (relatorio) |
 * |---------------------------|-------------|---------------------|
 * | `SAQUE ANTECIPCARD`       | EMPRESTIMO  | **cartao beneficio** |
 * | `CONSIG. BRADESCO`        | EMPRESTIMO  | emprestimo, por sorte |
 * | `IPREMN` `IRRF` `SINDSEP` | EMPRESTIMO  | nao e' consignacao   |
 *
 * A primeira linha e' o estrago: aquele cartao amortiza em 60 parcelas fixas de
 * valor constante — nem o texto nem o cronograma denunciam — e classificado como
 * emprestimo come os 35% em vez dos 5%, deixando o balde de cartao aparentemente
 * livre. O servidor passa a poder contratar cartao sobre um teto ja cheio.
 *
 * Ela acerta os nomes que foram INVENTADOS nos testes e erra os de verdade. Se
 * voce esta pensando em chamar isto pra decidir margem, use
 * `classificarVerba` em vez disso.
 *
 * NAO DECIDE MARGEM EM CAMINHO NENHUM — desde 01/09/2026, e agora e verdade.
 *
 * T009 tinha corrigido so o motor (`comprometidoNoBucket` le `ext.tipoMargem`,
 * gravado do catalogo). A auditoria de T059 encontrou QUATRO calculos irmaos em
 * `portal-banco/index.ts` ainda derivando o balde do TEXTO — :869 (o que a tela
 * exibe), :1437 (teto por contrato), :1696 (decide no editar) e :2873 (decide no
 * `persistir`). Para `SAQUE ANTECIPCARD` — cartao beneficio cujo texto diz
 * emprestimo — a tela comia os 35% e mostrava o teto de cartao livre, divergindo
 * do motor para o mesmo servidor.
 *
 * Fechado em T084: os quatro leem `ext.tipoMargem`. O alias
 * `bucketFromTombamento` sobrevive so como re-export de compatibilidade, e a
 * varredura de fonte de `portal-banco/trava-todos-os-canais.test.ts` reprova
 * qualquer uso de externo que volte a classificar balde sem ler o catalogo.
 *
 * Recebe ate' dois pedacos porque as fontes diferem: o tombamento trazia
 * `tipo` + `motivo`; o arquivo de consignados traz a DESCRICAO como sai no
 * holerite. Os dois sao concatenados e a busca e' por substring.
 *
 * Ordem importa: "cartao beneficio" contem "cartao", entao beneficio e'
 * testado primeiro. Sem isso todo cartao de beneficio cairia no balde do
 * cartao consignado.
 */
export function bucketPorDescricao(texto, complemento) {
    const t = `${texto ?? ""} ${complemento ?? ""}`.toLowerCase();
    if (t.includes("benef"))
        return "CARTAO_BENEFICIOS";
    if (t.includes("cartao") || t.includes("cartão"))
        return "CARTAO_CONSIGNADO";
    return "EMPRESTIMO";
}
//# sourceMappingURL=margem-bucket.js.map